export default __webpack_public_path__ + "2a9799ef8e7de811a3462add46677afc.png";